import { commonUtil } from '@/util'
const request = {}

request.createRequest = function (params) {
  const tmpProduct = params.registerData.product.data.map((ele) => {
    return { productId: ele.productId, productStorageMoveQuantity: ele.count }
  })
  return {
    shipStorageId: params.registerData.storage.ship.value,
    loadingStorageId: params.registerData.storage.loading.value,
    shipDestName: commonUtil.nullEmptyFormatNull(
      params.registerData.client.receiverInfo.fullName
    ),
    shipDestCountryId: commonUtil.nullEmptyFormatNull(
      params.registerData.client.receiverInfo.country.value
    ),
    shipDestPostalCode: commonUtil.nullEmptyFormatNull(
      params.registerData.client.receiverInfo.postalCode
    ),
    shipDestRegionId: commonUtil.nullEmptyFormatNull(
      commonUtil.formatRegion(
        params.registerData.client.receiverInfo.region,
        true
      )
    ),
    shipDestRegion: commonUtil.nullEmptyFormatNull(
      commonUtil.formatRegion(
        params.registerData.client.receiverInfo.region,
        false
      )
    ),
    shipDestAddress1: commonUtil.nullEmptyFormatNull(
      params.registerData.client.receiverInfo.address1
    ),
    shipDestAddress2: commonUtil.nullEmptyFormatNull(
      params.registerData.client.receiverInfo.address2
    ),
    shipDestPhoneNumberCountryId: commonUtil.nullEmptyFormatNull(
      params.registerData.client.receiverInfo.phone.countryCode.value
    ),
    shipDestPhoneNumber: commonUtil.nullEmptyFormatNull(
      params.registerData.client.receiverInfo.phone.phoneNumber
    ),
    trackingNumber: commonUtil.nullEmptyFormatNull(
      params.registerData.client.invoiceInfo.trackingNumber
    ),
    storageMoveDate: params.registerData.client.invoiceInfo.storageMoveDate,
    storageMoveReasonId:
      params.registerData.client.invoiceInfo.storageMoveReasonId.value,
    storageMoveProductList: tmpProduct,
    note: commonUtil.nullEmptyFormatNull(params.remarks)
  }
}
export default { request }
